import React from 'react';
import './FAQs.css'
import { logo } from '../../../assests/images/images'
import Header from '../../common/header/header'
import FooterContent from '../../common/footer/footer'
import { withTranslation } from "react-i18next";
import useFAQsHooks from './useFAQsHooks';
import Pagination from "react-js-pagination";
import { Link } from "react-router-dom";
import { FAQsService } from '../../../services/FAQsService';
import { Default } from '../../../assests/images/images';
import { Loading } from "../../../assests/images/images"
import { COLOR } from 'rsuite/esm/utils/constants';
import InfiniteScroll from 'react-infinite-scroller'


const FAQs = (props) => {
    const { t } = props;
    const { data,
        headerData,
        current,
        changeCurrentPage,
        searchHandler,
        deleteHandler,
        changeHandler,
        changeFileHandler,
        handleSubmit,
        editHandler,
        submitEdit,
        handleCancel,
        add,
        loader,
        isOpened,
        submitted,
        status,
        items,
        loadItems
    } = useFAQsHooks(props);


    const textstyle = {
        width: "100%",
        resize: "none",
        border: "1px solid #ced4da",
    }

    const TableContents = () => {
        return (
            <div className="stylish_table flt">
                {!loader && <div className="load flt">
                    <img src={Loading} alt="Stylish" />
                </div>}
                <div className="stylish_top mb-4 flt">
                    <div className="row">
                        <div className="col-sm-8">
                            <div className="page1_head flt">{t("FAQ")}<span className='lowercase'>s</span></div>
                        </div>
                        <div className="col-sm-4">
                            <div className="search_bar flt">
                                <input type="seach" placeholder="Search for title" onKeyUp={(e) => searchHandler(e)} className="form-control flt" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="fashion_main flt">

                    <div className="row">
                        <div className="col-sm-3">
                            <form className="fashion_left flt">
                                <div className="form-group flt">
                                    <label>{t("FAQ_header")}</label>

                                    <select name="faq_header" value={add.faq_header} onChange={changeHandler} className={'form-control flt' + (submitted && !add.faq_header.trim() ? ' is-invalid' : '')}>
                                        <option value='' key='' selected disabled>Please select </option>
                                        {headerData && headerData.data && headerData.data.data && headerData.data.data != null ? headerData.data.data.map((option) => (
                                            <option value={option._id} key={option._id}>{option.faq_header}</option>
                                        )) : null}
                                    </select>
                                    {submitted && !add.faq_header.trim() &&
                                        <div className="invalid-feedback">{t("Header_required")}</div>
                                    }
                                </div>
                                <div className="form-group flt">
                                    <label>{t("Title")}</label>
                                    <input type="text" name="faq_title" value={add.faq_title} onChange={changeHandler} className={'form-control flt' + (submitted && !add.faq_title.trim() ? ' is-invalid' : '')} />
                                    {submitted && !add.faq_title.trim() &&
                                        <div className="invalid-feedback">{t("Title_required")}</div>
                                    }
                                </div>
                                <div className="form-group flt">
                                    <label>{t("Description")}</label>
                                    <textarea name="faq_dsc" value={add.faq_dsc} onChange={changeHandler} className={'form-control flt' + (submitted && !add.faq_dsc.trim() ? ' is-invalid' : '')} style={textstyle}   ></textarea>
                                    {submitted && !add.faq_dsc.trim() &&
                                        <div className="invalid-feedback">{t("Description_Required")}</div>
                                    }
                                </div>
                                {isOpened &&
                                    <div className="form-group flt">
                                        <label>{t("Status")}</label>
                                        <select name="status" value={status} onChange={changeHandler} className={'form-control flt' + (submitted && !status ? ' is-invalid' : '')}>
                                            <option value="" key="" selected disabled>{t("Please_Select")}</option>
                                            <option value={1}>{t("Active")}</option>
                                            <option value={0}>{t("In_Active")}</option>
                                        </select>
                                    </div>
                                }
                                <div className="fashion_submit flt">
                                    {!isOpened && <button onClick={handleSubmit}>{t("Add")}</button>}
                                    {isOpened && <button onClick={submitEdit}>{t("Update")}</button>}
                                    {isOpened && <button onClick={handleCancel}>{t("Cancel")}</button>}
                                </div>
                            </form>
                        </div>
                        <div className="col-sm-9">
                            <div className="fashion_right flt">
                                {isOpened && <div className="table_overlay"></div>}
                                <div className="table-responsive">
                                    <table className="table convoc_table">
                                        <thead>
                                            <tr>
                                                <th width="80px">{t("Sl_No")}</th>
                                                <th width="200px">{t("FAQ_header")}</th>
                                                <th width="200px">{t("Title")}</th>
                                                <th>{t("Description")}</th>
                                                <th>{t("Status")}</th>
                                                <th width="120px">{t("Action")}</th>
                                                <th width="80px">{t("View")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {data && data.data && data.data.docs.length ? data.data.docs.map((list, index) => (
                                                <tr key={list._id}>
                                                    <td>{10 * (data.data.page - 1) + index + 1}.</td>
                                                    <td>{list?.faq_header}</td>
                                                    <td dangerouslySetInnerHTML={{ __html: list?.faq_title}}></td>
                                                    <td><div className="news_desc" dangerouslySetInnerHTML={{ __html: list?.faq_dsc}}></div></td>
                                                    <td>{list?.status == 1 ? "Active" : list?.status == 0 ? "Inactive" : ""}</td>
                                                    <td>
                                                        <button className='edit' onClick={() => editHandler(list._id)}><i className="fas fa-pencil-alt"></i> </button>
                                                        <button className='delete' onClick={() => deleteHandler(list._id)}><i className="fas fa-trash-alt"></i> </button>
                                                    </td>

                                                    <td><Link to={"/view-faq/" + list._id} className='view'><i class="fas fa-eye"></i></Link></td>
                                                </tr>
                                            )) :  <tr><td colSpan={7}><div className='no_data flt' >No data</div></td></tr> 
                                            }
                                        </tbody>
                                    </table>
                                </div>

                                <div className="row showrec">
                                    <div className="col-sm-6">
                                        {data && data.data &&
                                            <div className="ShowRec flt"> Showing {current} to {data.data.limit} of {data.data.docs.length} entries</div>}

                                    </div>
                                    <div className="col-sm-6">
                                        <div className="pagination_container flt">
                                            {data && data.data &&
                                                <Pagination
                                                    activePage={current}
                                                    itemsCountPerPage={10}
                                                    totalItemsCount={data.data && data.data.totalPages * data.data.limit}
                                                    pageRangeDisplayed={5}
                                                    onChange={changeCurrentPage}
                                                    firstPageText="First"
                                                    lastPageText="Last"
                                                    prevPageText="Previous"
                                                    nextPageText="Next"
                                                />

                                            }

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    return (
        <>
            <div className="main_container flt ">
                {Header()}
                <div className="page_container flt">

                    {TableContents()}
                </div>
                {FooterContent()}
            </div>
        </>
    )
}

export default withTranslation()(FAQs);



